import { useEffect } from 'react'

import _ from 'lodash'
import { useQuery } from 'react-query'

import { usePrevious } from 'peach/hooks'

import {
  useAuthIsRenewing,
  useAuthIsLoggingIn,
  useIsSessionActive,
} from 'core/auth/authStore'
import { useActiveKey } from 'core/stores/env'

const defaultConfig = {
  refetchOnMount: true,
  retry: 1,
}

const getIsEnabled = (config) => {
  const { forceEnabled, queryKey, enabled, disabled } = config || {}

  if (_.has(config, 'forceEnabled')) {
    return forceEnabled
  }

  if (_.some(queryKey, (key) => !key)) {
    return false
  }

  if (_.has(config, 'disabled')) {
    return !disabled
  }

  if (_.has(config, 'enabled')) {
    return enabled
  }
}

const useDataQuery = (options) => {
  const activeKey = useActiveKey()

  const { queryKey, queryFn, ...config } = options

  const isRenewing = useAuthIsRenewing()
  const isLoggingIn = useAuthIsLoggingIn()
  const isSessionActive = useIsSessionActive()

  const enabled = isSessionActive && getIsEnabled(options)

  const queryInfo = useQuery({
    queryKey: [activeKey, ...queryKey],
    queryFn: queryFn,
    ...defaultConfig,
    ...config,
    enabled,
  })

  const { data: queryData, error, refetch } = queryInfo

  const errorStatus = error?.status

  const isAuthing = isRenewing || isLoggingIn

  const previousIsAuthing = usePrevious(isAuthing)

  useEffect(() => {
    if (previousIsAuthing && !isAuthing) {
      if (errorStatus === 401) refetch()
    }
  }, [previousIsAuthing, isAuthing, errorStatus, refetch])

  const respData = queryData?.data || queryData

  const resp = [respData, queryInfo]

  Object.assign(resp, queryInfo)

  return resp
}

export default useDataQuery
